
import "/app/src/components/Layout/TopNavBanner.module.less?modules";
export default {"icon": `icon-njvY6pQX`,"label": `label-656lhFb0`,"banner": `banner-5FgvOpsI`,"item": `item-o9s_XJC3`,"active": `active-LDgsMrm1`}
